// extracted by css-extract-rspack-plugin
export default {"issueTypeTokenWrapper":"IssueTypeEvent-module__issueTypeTokenWrapper__eCdlTgQ"};